import React from 'react'
import {
  ACCREDITATION_STATUS_OPEN,
  ACCREDITATION_STATUS_HOLD,
  ACCREDITATION_STATUS_EXPIRED,
  ACCREDITATION_STATUS_ACCEPTED,
  ACCREDITATION_STATUS_REJECTED,
} from '../../config'

const StatusLabel = (props) => {
  let badge
  const { status } = props
  switch (status) {
    case ACCREDITATION_STATUS_OPEN:
      badge = <span className='label label-success text-uppercase'>{status}</span>
      break
    case ACCREDITATION_STATUS_HOLD:
      badge = <span className='label text-uppercase'>{status}</span>
      break
    case ACCREDITATION_STATUS_EXPIRED:
      badge = <span className='label label-information text-uppercase'>{status}</span>
      break
    case ACCREDITATION_STATUS_ACCEPTED:
      badge = <span className='label label-primary text-uppercase'>{status}</span>
      break
    case ACCREDITATION_STATUS_REJECTED:
      badge = <span className='label text-uppercase'>{status}</span>
      break
    default:
      badge = <span className='label text-uppercase'>{status}</span>
  }
  return badge
}

export default StatusLabel
